import { NgModule } from "@angular/core";
import { TreeNodeComponent, TreeComponent } from "./tree.component";
import { CommonModule } from "@angular/common";
import { FileListComponent, FileNode } from "./file_list.component";
import { FilePickerComponent } from "./file_picker.component";

import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';

@NgModule({
    imports:[
    FontAwesomeModule,
    CommonModule, 
    ],
    declarations:[
        TreeNodeComponent,TreeComponent, FileListComponent,FileNode, FilePickerComponent
    ],
    exports:[
        TreeNodeComponent,TreeComponent,FileListComponent,FileNode, FilePickerComponent
    ]
})
export class FdmFilesModule{}